var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.317 34.6001L35.117 33.4001C35.7337 32.4668 36.1003 31.3334 36.1003 30.1334C36.1003 26.8334 33.4337 24.1667 30.1337 24.1667C26.8337 24.1667 24.167 26.8334 24.167 30.1334C24.167 33.4334 26.8337 36.1001 30.1337 36.1001C31.3503 36.1001 32.467 35.7334 33.4003 35.1168L34.6003 36.3168C34.8336 36.5501 35.1503 36.6667 35.4503 36.6667C35.767 36.6667 36.067 36.5501 36.3003 36.3168C36.7837 35.8334 36.7836 35.0668 36.317 34.6001Z",
    fill: "#1F2937"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.38295 24.3831C3.38295 24.4331 3.34961 24.4997 3.34961 24.5497C4.88294 27.6164 7.38296 30.133 10.4496 31.6497C10.4996 31.6497 10.5663 31.6164 10.6163 31.6164C10.0496 29.6831 9.61629 27.6997 9.29962 25.7164C7.29962 25.383 5.31628 24.9497 3.38295 24.3831Z",
    fill: "#04EEAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M31.7831 10.7165C30.2165 7.43314 27.5665 4.78315 24.2998 3.23315C24.8998 5.21649 25.3998 7.24983 25.7331 9.28316C27.7665 9.6165 29.7998 10.0998 31.7831 10.7165Z",
    fill: "#04EEAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.21582 10.7167C5.21582 10.1167 7.24918 9.61673 9.28251 9.2834C9.61584 7.30006 10.0325 5.3334 10.5992 3.40007C10.5492 3.40007 10.4825 3.3667 10.4325 3.3667C7.29916 4.9167 4.74915 7.53337 3.21582 10.7167Z",
    fill: "#04EEAD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.0325 8.93323C22.6325 6.76656 22.1325 4.59992 21.4158 2.49992C21.3825 2.38325 21.3825 2.28327 21.3658 2.14993C20.1325 1.84993 18.8325 1.6499 17.4992 1.6499C16.1492 1.6499 14.8658 1.83327 13.6158 2.14993C13.5992 2.2666 13.6158 2.36659 13.5825 2.49992C12.8825 4.59992 12.3658 6.76656 11.9658 8.93323C15.6492 8.53323 19.3492 8.53323 23.0325 8.93323Z",
    fill: "#04EEAD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.93372 11.9666C6.75038 12.3666 4.60038 12.8666 2.50038 13.5832C2.38371 13.6166 2.2837 13.6166 2.15037 13.6332C1.85037 14.8666 1.65039 16.1666 1.65039 17.4999C1.65039 18.8499 1.8337 20.1332 2.15037 21.3832C2.26704 21.3999 2.36705 21.3832 2.50038 21.4166C4.60038 22.1166 6.75038 22.6332 8.93372 23.0332C8.53372 19.3499 8.53372 15.6499 8.93372 11.9666Z",
    fill: "#04EEAD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.8331 13.6332C32.7165 13.6332 32.6165 13.6166 32.4831 13.5832C30.3831 12.8832 28.2165 12.3666 26.0498 11.9666C26.4665 15.6499 26.4665 19.3499 26.0498 23.0166C28.2165 22.6166 30.3831 22.1166 32.4831 21.3999C32.5998 21.3666 32.6998 21.3832 32.8331 21.3666C33.1331 20.1166 33.3331 18.8332 33.3331 17.4832C33.3331 16.1665 33.1498 14.8832 32.8331 13.6332Z",
    fill: "#04EEAD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.9658 26.0669C12.3658 28.2502 12.8658 30.4002 13.5825 32.5002C13.6158 32.6169 13.5992 32.7169 13.6158 32.8502C14.8658 33.1502 16.1492 33.3502 17.4992 33.3502C18.8325 33.3502 20.1325 33.1669 21.3658 32.8502C21.3825 32.7335 21.3825 32.6335 21.4158 32.5002C22.1158 30.4002 22.6325 28.2502 23.0325 26.0669C21.1992 26.2669 19.3492 26.4169 17.4992 26.4169C15.6492 26.4002 13.7992 26.2669 11.9658 26.0669Z",
    fill: "#04EEAD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.583 11.5835C11.083 15.5168 11.083 19.4835 11.583 23.4335C15.5163 23.9335 19.483 23.9335 23.433 23.4335C23.933 19.5001 23.933 15.5335 23.433 11.5835C19.483 11.0835 15.5163 11.0835 11.583 11.5835Z",
    fill: "#04EEAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalSearch);
export default __webpack_public_path__ + "static/media/global-search.1bbc797b33588f72631835f6b99698fc.svg";
export { ForwardRef as ReactComponent };